import axiosConfig from "./axiosConfig";

export interface RenameLeadSearchRequest {
  searchId: string;
  name: string;
}

export interface RenameLeadSearchResponse {
  id: string;
  name: string;
}

// Renaming also moves the search's tag on every lead promoted from it, so the
// batch stays findable under the new name. A name already used by another
// search is rejected with 409 rather than merged - two searches sharing a name
// would share one chip in the leads tag filter with no way to separate them.
const patchLeadSearch = async (
  authToken: string,
  { searchId, name }: RenameLeadSearchRequest
): Promise<RenameLeadSearchResponse> => {
  const { data } = await axiosConfig.patch(
    `/leads/searches/${encodeURIComponent(searchId)}`,
    { name },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default patchLeadSearch;
